import request from "@/utils/request";

// 查询工单工作台-cc-mo票列表
export function apiGetMesDiscreteJobsCcMo (data) {
  return request({
    url: '/mes/mesDiscreteJobsCcMo/list',
    method: 'post',
    data: data
  })
}

// 导出工单工作台-cc-mo票列表
export function apiExportMesDiscreteJobsCcMo (data) {
  return request({
    url: '/mes/mesDiscreteJobsCcMo/export',
    method: 'post',
    data: data
  })
}

// mo票批量关闭
export function apiBatchCloseMesDiscreteJobsCcMo (data) {
  return request({
    url: '/mes/mesDiscreteJobsCcMo/batchClose',
    method: 'post',
    data: data
  })
}

// mo票批量撤销派工
export function apiRevokeDispatchMesDiscreteJobsCcMo (data) {
  return request({
    url: '/mes/mesDiscreteJobsCcMo/revokeDispatch',
    method: 'post',
    data: data
  })
}

// 查询工单工序-cc列表
export function apiGetMesOperationsCc (data) {
  return request({
    url: '/mes/mesOperationsCc/list',
    method: 'post',
    data
  })
}

// 查询领料-汇总数据
export function apiGetMesRequisitionCcList (data) {
  return request({
    url: '/mes/mesRequisitionCcDetail/list',
    method: 'post',
    data
  })
}

// 发起领料-材料明细
export function apiGetMesRequisitionCcDetailList (data) {
  return request({
    url: '/mes/mesRequisitionCcDetail/detailList',
    method: 'post',
    data
  })
}

// 发起领料-查询领料记录
export function apiGetMesRequisitionCcPickIngLog (params) {
  return request({
    url: '/mes/mesRequisitionCc/listPickIngLog',
    method: 'get',
    params
  })
}

// 发起领料-提交
export function apiProdPicking (data) {
  return request({
    url: '/mes/mesRequisitionCc/prodPicking',
    method: 'post',
    data
  })
}

// 领料单MO票详情列表
export function apiGetMoDetailList (params) {
  return request({
    url: '/mes/mesRequisitionCcDetail/moDetailList',
    method: 'get',
    params
  })
}

// 领料单详情列表
export function apiGetRequisitionDetailList (params) {
  return request({
    url: '/mes/mesRequisitionCcDetail/requisitionDetailList',
    method: 'get',
    params
  })
}

// 修改MO票接口
export async function updateMesDiscreteJobsMo (data) {
  return request({
    url: '/mes/mesDiscreteJobsCcMo/edit',
    method: 'post',
    data
  })
}

// 关联工单
export function apiGetJobsCcAssociateListMo (data) {
  return request({
    url: '/mes/mesDiscreteJobsCcMo/associateList',
    method: 'post',
    data
  })
}

// 导出关联工单
export function apiExportJobsCcAssociateListMo (data) {
  return request({
    url: '/mes/mesDiscreteJobsCcMo/associateExport',
    method: 'post',
    data
  })
}

// 导出工序清单
export function apiExportOperationsCcMo (data) {
  return request({
    url: '/mes/mesOperationsCc/export',
    method: 'post',
    data
  })
}

// 导出用料表-MO票
export async function apiExportRequirementOperationsMo (params) {
  return request({
    url: '/mes/mesRequirementOperationsCcMo/export',
    method: 'post',
    data: params
  })
}

// 查询工单用料-MO票列表
export async function apiRequirementOperationsMoList (data) {
  return request({
    url: '/mes/mesRequirementOperationsCcMo/list',
    method: 'post',
    data
  })
}

// 打印领料单-校验派工数量是否超过工单数量
export async function apiCheckDispatchQuantityMo (data) {
  return request({
    url: '/mes/mesDiscreteJobsCcMo/checkDispatchQuantity',
    method: 'post',
    data
  })
}

// 打印领料单-获取打印列表
export async function apiGetMaterialPrintListMo (data) {
  return request({
    url: '/mes/mesDiscreteJobsCcMo/getMaterialPrintList',
    method: 'post',
    data
  })
}

// 打印领料单-合单打印领料单
export async function apiGetMaterialPrintListMerge (data) {
  return request({
    url: '/mes/mesDiscreteJobsCcMo/getMaterialPrintListMerge',
    method: 'post',
    data
  })
}

// 打印领料单-更新派工数量
export async function apiUpdateDispatchQuantityMo (data) {
  return request({
    url: '/mes/mesDiscreteJobsCcMo/updateDispatchQuantity',
    method: 'post',
    data
  })
}

// 打印领料单-更新打印领料单次数
export async function apiUpdatePrintTimesMo (data) {
  return request({
    url: '/mes/mesDiscreteJobsCcMo/updatePrintTimes',
    method: 'post',
    data
  })
}

// 查看已领数量明细
export async function apiGetLabelIDetailList (data) {
  return request({
    url: '/mes/mesRequisitionCcDetail/labelDetailList',
    method: 'get',
    params: data
  })
}

// 批量更新数据
export function apiBatchUpdateMesDiscreteJobsCc (data) {
  return request({
    url: `/mes/mesDiscreteJobsCcMo/batchEdit`,
    method: 'post',
    data: data
  })
}
